<template>
    <div>
        <div class="container my-5">
            <div class="row">
                <div class="col-md-3 col-sm-12 order-md-1 order-sm-2 order-2 colofon">
                    <h2>Impressum</h2>
                    <i>© 2025 Copyright Gemeente Enschede</i>
                    <p>
                        Das Lehrmaterial, die Bilder/Zeichnungen und das Konzept dürfen ausschließlich für
                        Bildungszwecke
                        frei verwendet werden.
                        Wenn Sie Fragen zu dem Lehrmaterial haben, senden Sie bitte eine E-Mail an:
                        <a href="mailto:expertisecentrum@edl.euregio.eu">expertisecentrum@edl.euregio.eu</a>
                    </p>

                    <h2>Projektleiterin (inhaltlich)</h2>
                    <p>Marleen van Grunsven</p>

                    <h2>Illustratorinnen</h2>
                    <p>
                        <a href="https://www.sjusjun.com/nl/">Corona Zschusschen - Sjusjun</a><br>
                        <a href="http://www.studioappeltjesgroen.com/">Linda van Ballegooijen - studio
                            Appeltjesgroen</a>
                        <br>
                        <a href="http://www.3link.be">Katrien van Schuylenbergh - 3link</a>
                    </p>

                    <h2>Projektleiterin (Design)</h2>
                    <p><a href="http://www.queenie.nl">Petra ter Keurs - Queenie Productions</a></p>
                

                    <h2>Programmierer Website</h2>
                    <p><a href="http://www.focussing.nl">Raymond Verbruggen - Focussing Borne</a></p>

                    <h2>Deutsche Übersetzung</h2>
                    <p>Judith Reef, Lorenz Doleschal – DNL-contact</p>

                    <h2>Vielen Dank an</h2>
                    Uta Maria Cyprian – Bezirksregierung Münster<br>
                    Barbara Verbeek – Gemeente Enschede<br>
                    Leanne Jansen – Praten met Pim<br>
                    Yvette Reuver – Praten met Pim<br>
                    Ulrike Nachtigäller – Universität Münster<br>
                    Franziska Vehling – Universität Münster<br>

                    <!-- <h2>Colofon</h2>
                    <p>
                        <i>© {{ year }} Copyright Gemeente Enschede</i>
                        <br />Das Material, die Bilder/Zeichnungen und das Konzept dürfen nur für Bildungszwecke
                        verwendet werden. <br />Wenn Sie Fragen zum Material haben, senden Sie bitte eine E-Mail an:
                        pratenmetpim@gmail.com
                    </p>

                    <h2>Initiatoren</h2>
                    <p>Rianne Buist und Leanne Jansen</p>

                    <h2>Projektleiter (inhaltlich)</h2>
                    <p>Yvette Reuver (Koordinator), Anouk Lormans und Leanne Jansen</p>

                    <h2>Illustratoren</h2>
                    <p>
                        <a href="https://www.sjusjun.com/nl/">Corona Zschusschen - Sjusjun</a>
                    </p>
                    <p>
                        <a href="http://www.studioappeltjesgroen.com/">Linda van Ballegooijen - studio
                            Appeltjesgroen</a>
                    </p>
                    <p>
                        <a href="http://www.3link.be">Katrien van Schuylenbergh - 3link</a>
                    </p>

                    <h2>Projektleiter (Design)</h2>
                    <p>
                        <a href="http://www.queenie.nl">Petra ter Keurs - Queenie Productions</a>
                    </p>

                    <h2>Website-Programmierer</h2>
                    <p>
                        <a href="http://www.focussing.nl">Raymond Verbruggen - Focussing Borne</a>
                    </p>

                    <h2>Mit Dank an</h2>
                    <p>Gemeente Enschede: <br />Agnes Eshuis und Hans Koier</p> -->

                </div>

                <div class="col-md-9 col-sm-12 order-ms-2 order-sm-1 order-1">
                    <h2>Vorwort</h2>
                    <p>
                        Jedes Kind braucht Sprache, um sich ausdrücken zu können. Worte zum Spielen, Worte zum Sprechen
                        und Worte, um zu sagen was man braucht. Plaudern mit Pim ist ein Wortschatzprogramm, mit dem
                        jedes Kind lernen kann, sich sprachlich auszudrücken. Damit wird eine stabile Grundlage für
                        lebenslanges Lernen geschaffen. Jedes Kind darf schließlich lernen, was es lernen kann. Pim
                        begleitet die Kinder beim Erlernen der Wörter.
                    </p>
                    <p>
                        Plaudern mit Pim bietet Materialien für ein durchdachtes Wortschatzangebot für junge Kinder. Die
                        Materialen sind methodenunabhängig. Die Kinder erleben das Wortschatzangebot als unterschiedlich
                        intensiv. Eines jedoch gilt für alle Kinder gleichermaßen: Lernen ist ein Kinderspiel. Das
                        heißt:
                        spielen, spielen und noch mehr spielen! Sprache erleben durch Fühlen, Sehen, Hören und Spielen.
                        Die
                        Illustrationen von Pim übersetzen die Wörter in den Alltag – konkrete Bilder, die den Kindern
                        helfen, sich die Wörter besser zu merken.</p>
                    <p>
                        Die niederländische Website „Praten met Pim” wurde im Auftrag der Gemeinde Enschede für Kinder
                        im
                        Vorschul- und Grundschulalter entwickelt – in Zusammenarbeit mit pädagogischen Fachkräften,
                        Lehrkräften und Coaches der frühkindlichen Bildung. Die Kinder in den Spielgruppen,
                        Kindertagesstätten und Grundschulen in Enschede haben Pim inzwischen bereits kennengelernt.
                    </p>
                    <p>
                        Wörter in der Sprache, die einen umgibt– darum geht es. Das Projekt Euregionale Doorlopende
                        Leerlijn
                        arbeitet daran, die Hürden der Grenze zwischen den Niederlanden und Deutschland zu überwinden.
                        Im
                        Rahmen des Projekts ergab sich die Möglichkeit, „Praten met Pim” ins Deutsche zu übersetzen. So
                        kann
                        Pim im Nachbarsprachenunterricht auf beiden Seiten der Grenze eingesetzt werden. In den
                        Illustrationen wurde versucht, Elemente des Alltagslebens in Deutschland so authentisch wie
                        möglich
                        darzustellen. So kann spielerisch am deutschen Wortschatz gearbeitet werden und niederländische
                        Kinder erhalten mit Pim einen kleinen Blick über die Grenze.
                    </p>
                    <p>
                        Die Website richtet sich an niederländische Grundschulen und Lehrkräfte, die auf einfache und
                        kindgerechte Weise mit dem Erwerb der deutschen Sprache beginnen möchten. Sie eignet sich ebenso
                        gut
                        für den Deutschunterricht in Deutschland – beispielsweise in Kindertagesstätten, Schulen oder
                        beim
                        Spracherwerb von deutsch- oder anderssprachigen Kindern.
                    </p>
                    <p>
                        Wir wünschen Ihnen viel <span class="font-weight-bold">Freude beim Plaudern und Spielen mit
                            Pim!</span>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import top from './Top.vue';

export default {
    components: {
        top,
    },

    data: () => ({
        year: new Date().getFullYear(),
    }),

    created() {
        console.clear();
    },

    methods: {},
};
</script>

<style scoped>
.container {
    text-align: left;
}

.colofon {
    font-size: 0.85rem;
    color: #03965b;
}

h2 {
    font-size: 1.25rem;
}

.colofon h2 {
    font-size: 1rem;
}

a {
    color: #03965b;
}

ul {
    padding-inline-start: 15px;
}
</style>
